export default __webpack_public_path__ + "static/media/5.4d0a3b46.jpg";